/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalDistribute: {
  name: 'vertical-distribute';
  data: string;
} = {
  name: 'vertical-distribute',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 2v2H2V2h20zM7 10.5v3h10v-3H7zM2 20v2h20v-2H2z"/></svg>`
};
